import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toRichTextFromProp, toTextFromProp } from '../../fields/text';

export const insertSlice = ({ primary }) =>
  clear({
    type: CommonSliceType.INSERT,
    title: toTextFromProp('title', primary),
    description: toRichTextFromProp('insert', primary),
  });
